import styled from 'styled-components/macro';

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default ButtonContainer;
